































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconArrowRight,
    NextPrevBtn,
    Footer,
  },
})
export default class SpeechDare extends Vue {
  protected nxtprevSpeechDare = {
    BoolPrev: false,
    BoolNext:  true,
    PrevImage: "",
    NextImage: "/thumbnail4.png",
    PrevLink: "",
    NextLink: "/Prise_de_Parole/Parametre_Parole",
  };
}
